import { useTranslation } from 'next-i18next';
import {
  isFullMecProduct,
  ProductForComparison,
} from '@adapters/bigcommerce/types/product';
import { useComparison } from '@context/CompareContext';
import Checkbox from '_components/UI/Inputs/Checkbox';

import styles from './ProductComparisonCheckbox.module.scss';

interface ProductComparisonCheckboxProps {
  product: ProductForComparison;
}

const ProductComparisonCheckbox = ({
  product,
}: ProductComparisonCheckboxProps) => {
  const { t } = useTranslation('comparison');

  const { addItem, removeItem, allItems, addPendingItem } = useComparison();

  if (!product.code) return null;

  const toggleComparison = () => {
    if (!product.code) return;

    if (allItems.includes(product.code)) {
      removeItem(product.code);
    } else {
      // On the product page we have a lot more data available than in the search results.
      if (isFullMecProduct(product)) {
        addItem(product); // TODO: comparison uses default variant only; consider GraphQL query for selected variant (backlog)
      } else {
        // by adding it to the pending items we can fetch the product data later.
        addPendingItem(product.code);
      }
    }
  };

  const isSelected = allItems.includes(product.code);

  return (
    <div>
      <Checkbox
        id={`product-comparison-checkbox-${product.code}`}
        label={<span className={styles.checkboxLabel}>{t('compare')}</span>}
        onChange={toggleComparison}
        checked={isSelected}
        variant="small"
        labelId={`product-comparison-checkbox-label-${product.code}`}
      />
    </div>
  );
};

export default ProductComparisonCheckbox;
